import { render, staticRenderFns } from "./beneficiaries-review.component.vue?vue&type=template&id=2171bb10&"
import script from "./beneficiaries-review.component.vue?vue&type=script&lang=ts&"
export * from "./beneficiaries-review.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports